export const getMindEdgeStyle = (themeColor) => {
  let mindEdgeStyle = { lineWidth: 2, stroke: themeColor };
  return mindEdgeStyle;
};
export const getMindNodeStyle = (
  themeColor,
  btnTextColor,
  firstBgColor,
  secondBgColor,
  thirdTextColor,
  lineThemeColor
) => {
  let mindNodeStyle = {
    //节点默认背景颜色
    btnStyle: {
      fill: "transparent",
      stroke: "transparent",
      lineWidth: 2,
    },
    //节点背景颜色数组
    btnStyles: [
      { fill: firstBgColor, stroke: firstBgColor, lineWidth: 2 },
      { fill: secondBgColor, stroke: secondBgColor, lineWidth: 2 },
    ],
    //节点文本颜色数组
    btnTextStyles: [
      { fill: btnTextColor, fontWeight: 700, fontSize: 16 },
      { fill: thirdTextColor, fontWeight: 600, fontSize: 14 },
    ],
    //重要果实hover和selected样式
    btnTypeStyles: {
      1: {
        // hoverFill: "#ffd6d6",
        // selectedFill: "#ffd6d6",
        hoverStroke: "#DF7271",
        selectStroke: "#DF7271",
        // hoverTextColor: "#333",
        // selectTextColor: "#333",
        show: false, //图标是否显示
      },
    },
    //重要果实的配置
    specialStyle: {
      1: {
        fontFamily: "iconfont",
        fill: "#DF7271",
        text: "\ue604",
        fontSize: 14,
        fontWeight: 700,
      },
    },
    //节点hover边框颜色
    btnHoverStyle: {
      stroke: themeColor,
    },
    // 节点hoverd多层样式
    btnHoverStyles: [
      {
        fill: firstBgColor,
        stroke: themeColor,
      },
      {
        fill: secondBgColor,
        stroke: themeColor,
      },
    ],
    //节点selected边框颜色
    btnSelectedStyle: {
      stroke: themeColor,
    },
    //节点selected多层边框颜色
    btnSelectedStyles: [
      {
        stroke: themeColor,
      },
    ],
    // 孙节点文本默认颜色
    btnTextStyle: {
      fill: thirdTextColor,
      fontSize: 14,
      fontStyle: "normal",
      fontWeight: 400,
      fontFamily:
        '"Microsoft YaHei", "PingFang SC", "Microsoft JhengHei", sans-serif',
      textBaseline: "middle",
      lineHeight: 25,
      maxCount: 16,
      maxWidth: 200,
    },
    // 数字文本颜色
    collapsedNumberTextStyle: {
      fill: themeColor,
      fontSize: 12,
    },
    // 数字背景颜色
    collapsedNumberStyle: {
      fill: "transparent",
    },
    // 加减号背景颜色
    collapsedSelectedStyle: {
      r: 9,
      lineWidth: 2,
      fill: themeColor,
      stroke: themeColor,
    },
    // 加减号文本颜色
    collapsedSelectedTextStyle: {
      fill: "#ebebeb",
      fontSize: 16,
      lineHeight: 18,
      fontWeight: 600,
      fontFamily: "iconfont",
    },
    linkIconStyle: {
      link1: 'data:image/svg+xml;charset=utf-8,%3Csvg%20width%3D%2259%22%20height%3D%2258%22%20viewBox%3D%220%200%2059%2058%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%22-2.06248%22%20y%3D%222.06248%22%20width%3D%2220.6248%22%20height%3D%2220.6248%22%20rx%3D%222.06248%22%20transform%3D%22matrix(-1%200%200%201%2037.75%2016.625)%22%20stroke%3D%22%235CAEFA%22%20stroke-width%3D%224.12496%22%2F%3E%3Crect%20width%3D%2216.4999%22%20height%3D%2216.4999%22%20rx%3D%224.12496%22%20transform%3D%22matrix(-1%200%200%201%2050.1248%2033.125)%22%20fill%3D%22%235CAEFA%22%2F%3E%3Crect%20width%3D%2216.4999%22%20height%3D%2216.4999%22%20rx%3D%224.12496%22%20transform%3D%22matrix(-1%200%200%201%2025.375%208.375)%22%20fill%3D%22%235CAEFA%22%2F%3E%3C%2Fsvg%3E',
      link2: 'data:image/svg+xml;charset=utf-8,%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M14.3721%2030.871C14.3721%2029.9283%2015.074%2029.1332%2016.0093%2029.0163L17.2897%2028.8563C23.3376%2028.1003%2028.1013%2023.3366%2028.8572%2017.2887L29.0173%2016.0083C29.1342%2015.073%2029.9293%2014.3711%2030.8719%2014.3711V14.3711V14.3711C31.8145%2014.3711%2032.6097%2015.073%2032.7266%2016.0083L32.8866%2017.2887C33.6426%2023.3366%2038.4063%2028.1003%2044.4542%2028.8563L45.7345%2029.0163C46.6699%2029.1332%2047.3718%2029.9283%2047.3718%2030.871V30.871C47.3718%2031.8136%2046.6699%2032.6087%2045.7345%2032.7256L44.4542%2032.8856C38.4063%2033.6416%2033.6426%2038.4053%2032.8866%2044.4532L32.7266%2045.7336C32.6097%2046.6689%2031.8145%2047.3708%2030.8719%2047.3708V47.3708C29.9293%2047.3708%2029.1342%2046.6689%2029.0173%2045.7336L28.8572%2044.4532C28.1013%2038.4053%2023.3376%2033.6416%2017.2897%2032.8856L16.0093%2032.7256C15.074%2032.6087%2014.3721%2031.8136%2014.3721%2030.871V30.871Z%22%20fill%3D%22%23A48AFF%22%2F%3E%3Cpath%20d%3D%22M0.620605%2011.619C0.620605%2010.9995%201.09663%2010.481%201.71424%2010.4316V10.4316C6.36662%2010.0594%2010.0608%206.36516%2010.433%201.71277V1.71277C10.4824%201.09516%2011.0009%200.619141%2011.6205%200.619141V0.619141V0.619141C12.2401%200.619141%2012.7586%201.09516%2012.808%201.71277V1.71277C13.1802%206.36516%2016.8744%2010.0594%2021.5268%2010.4316V10.4316C22.1444%2010.481%2022.6204%2010.9995%2022.6204%2011.619V11.619C22.6204%2012.2386%2022.1444%2012.7571%2021.5268%2012.8065V12.8065C16.8744%2013.1787%2013.1802%2016.8729%2012.808%2021.5253V21.5253C12.7586%2022.1429%2012.2401%2022.619%2011.6205%2022.619V22.619C11.0009%2022.619%2010.4824%2022.1429%2010.433%2021.5253V21.5253C10.0608%2016.8729%206.36662%2013.1787%201.71424%2012.8065V12.8065C1.09663%2012.7571%200.620605%2012.2386%200.620605%2011.619V11.619Z%22%20fill%3D%22%23A48AFF%22%2F%3E%3C%2Fsvg%3E',
    },
    // 关联模型
    linkDotStyle: {
      fill: lineThemeColor,
      r: 4,
    },
    linkLabelBgStyle: {
      fill: '#666',
      marginRight: 50,
      borderStyle: {
        lineDash: [8, 8], // 虚线的形状：[实线长度，间隔长度]
        stroke: '#999', // 边的颜色
        lineWidth: 2, // 边的宽度
      }
    },
    linkLabelLineStyle: {
      stoke: themeColor,
    },
    linkLabelTextStyle: {
      fontStyle: "normal",
      fontFamily:
        '"Microsoft YaHei", "PingFang SC", "Microsoft JhengHei", sans-serif',
      fill: "#fff",
      fontSize: 12,
      fontWeight: 400,
      textAlign: "left",
      textBaseline: "middle",
      lineHeight: 10,
      maxWidth: 200,
    },
    //   //双线图标
    doubleIconStyle: {
      fontFamily: "iconfont",
      fill: "#a48aff",
      text: "\ue8d3",
      fontSize: 14,
      fontWeight: 700,
    },
    //   //link ready
    //   linkReadyStyle: {
    //     stroke: lineThemeColor,
    //     btnStyle: {
    //       fill: lineThemeColor,
    //     },
    //     btnTextStyle: {
    //       fontFamily: "iconfont",
    //       fill: "#fff",
    //       text: "\ueaf3",
    //       fontWeight: 600,
    //       fontSize: 10,
    //     },
    //   },
  };
  return mindNodeStyle;
};
export const getMindEdgeLinkStyle = (lineThemeColor) => {
  let mindEdgeLinkStyle = {
    //双线标签背景
    edgeLabelBgStyle: { fill: lineThemeColor },
    //双线标签文字
    edgeLabelTextStyle: {
      fontStyle: "normal",
      fontFamily:
        '"Microsoft YaHei", "PingFang SC", "Microsoft JhengHei", sans-serif',
      fill: "#222",
      fontSize: 12,
      fontWeight: 400,
      textAlign: "left",
      textBaseline: "middle",
      lineHeight: 10,
      maxWidth: 200,
    },
    //线条样式
    edgePathStyle: { stroke: lineThemeColor, shadowColor: "#4f8946" },
    //线条中间点样式
    edgeDotStyle: { fill: lineThemeColor, r: 2 },
    //线条两端小圆圈
    circleDotStyle: {
      r: 4,
      lineWidth: 2,
      stroke: lineThemeColor,
      fill: "#fff",
    },
    //双线中间的箭头
    arrowStyle: {
      path: `M 0,0 L 9,9, L 0,0 L 9,-9 Z`,
      stroke: lineThemeColor,
      fill: lineThemeColor,
      lineDash: [1, 1],
    },
  };
  return mindEdgeLinkStyle;
};
